import React from 'react';
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import ErrorBoundary from "components/Error/errorBoundary";
import LoginModelPage from "v4/pages/front/Login/components/LoginModelPage";
import resetPasswordImg from "img/reset-password.svg";
import FormRender from "v4/components/form/FormRender/FormRender";
import FormRest from "v4/components/form/FormRender/components/FormRest/FormRest";
import LoginField from "v4/pages/front/Login/components/LoginField";
import SubmitButton from "v4/components/ui/SubmitButton/SubmitButton";
import useResetPasswordChange
    from "v4/pages/front/ResetPassword/components/ResetPasswordChange/hooks/useResetPasswordChange";
import {routesBase} from "v4/data/appRoutes";
import {Redirect} from "react-router-dom";

export default function ResetPasswordChange({userId, token}) {
    const {t} = usePolTranslation();
    const {
        form,
        formErrors,
        errorMessages,
        onSubmit,
        isSaveLoading,
    } = useResetPasswordChange(userId, token);

    if (!token) return <Redirect to={routesBase.baseLogin}/>

    return (
        <ErrorBoundary>
            <LoginModelPage imageLeftRender={() => <img src={resetPasswordImg} alt=""/>}
                            goBackTo={routesBase.baseLogin}>
                <p className="login__form__title">{t('reset_password')}</p>
                <p className="login__form__text mb-3">{t('reset_password_tip')}</p>

                <FormRender form={form}
                            formErrors={formErrors}
                            onSubmit={onSubmit}
                            fieldRender={(field, formRenderMethods) => (
                                <LoginField field={field} formRenderMethods={formRenderMethods}/>
                            )}
                >
                    <FormRest/>

                    <SubmitButton isLoading={isSaveLoading} additionalClassName="login__form__btn">
                        {t('edit_password')}
                    </SubmitButton>

                    <div className="mt-3">
                        {errorMessages && (
                            errorMessages.map((message, index) => (
                                <p key={index} className="login__form__error">{t(message)}</p>
                            ))
                        )}
                    </div>
                </FormRender>
            </LoginModelPage>
        </ErrorBoundary>
    )
}
